import React, { useRef } from 'react';
import useFullscreen from '../hooks/useFullscreen';
import Office413Video from '../Assets/413Office.mp4';

function Office413() {
  const pageRef = useRef(null);
  const { isFullscreen, toggleFullscreen } = useFullscreen(pageRef);

  return (
    <div
      ref={pageRef}
      className="office413-video-page"
      onDoubleClick={toggleFullscreen}
    >
      <video
        className="office413-video-frame"
        src={Office413Video}
        title="413 Office video"
        autoPlay
        muted
        loop
        playsInline
        controls={false}
      />
      <button
        type="button"
        className="fullscreen-toggle-button"
        onClick={toggleFullscreen}
        aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      >
        {isFullscreen ? 'EX' : 'FS'}
      </button>
      <style>{`
        .office413-video-page {
          position: fixed;
          inset: 0;
          background: #000;
          overflow: hidden;
        }

        .office413-video-frame {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }
      `}</style>
    </div>
  );
}

export default Office413;
